import EditorVM from './editor-vm';
export default {
  init: function(){
    // self.addSelectEvents();
    var data = JSON.parse($('#resource_json').val());

    var validationOptions = Kadenze.Knockout.DEFAULT_VALIDATION_OPTIONS;
    var ele = document.getElementById('resource_edit_form');
    var vm = new EditorVM(data.resource, ele, false, data.course_id);
    ko.applyBindingsWithValidation(vm, ele, validationOptions);
  }
};
